export const external_urls = {
  pogr_sdk: 'https://github.com/pogrio',
  pogr_api_documentation: 'https://pogrio.github.io/api-docs/',
};
